import api from '../../configuration/api'

export const users = {
  update: (id, data) => api.put('users/' + id, data),
  publicData: (id) => api.get('users/' + id + '/public'),
  applyToken: (data) => api.post('users/token', data),
};
